import { ImgHTMLAttributes } from "react";

const WebpImage = (props: ImgHTMLAttributes<HTMLImageElement>) => {
	const { src } = props;
	const isSvg = src!.endsWith(".svg");
	const webpSrc = src!
		.replace("/onepoint/", "/webp-onepoint/")
		.replace(/\.(png|jpg|jpeg)$/, ".webp");
	const { loading, alt, ...rest } = props;

	return (
		<picture
			style={{
				display: "flex",
				flexShrink: 0,
			}}
		>
			{!isSvg && <source srcSet={webpSrc} type="image/webp" />}
			<img {...rest} loading={loading || "lazy"} alt={alt || src} />
		</picture>
	);
};

export default WebpImage;
